export default {
  GET_ACTIVITY_PAGE: '/activity/getActivityPage',
  GET_ACTIVITY_RANK: '/Activity/GetContributeUserRank',
  GET_ACTIVITY_LIST: '/Activity/GetContributeList',
  GET_ACTIVITY_HQ_LIST: '/Activity/GetHQContributeList',
  GET_ACTIVITY_MUSIC_LIST: '/activity/GetActivityMusic',
  GET_ACTIVITY_PAGE_V3_API: '/ActivityTemplate/getActivityPage',
};
